import React from 'react'
import {Icon} from '@chakra-ui/react'

const CardPreviewIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 10V0H0V10H10ZM2 8V2H8V8H2ZM16 2V8H22V2H16ZM24 10V0H14V10H24ZM2 16V22H8V16H2ZM10 24V14H0V24H10ZM16 16V22H22V16H16ZM24 24V14H14V24H24Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CardPreviewIcon
